var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 10,
    viewBox: "0 0 24 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34656 8H2.79456V2.28H5.20256C6.37856 2.28 7.06656 2.808 7.06656 3.72C7.06656 4.424 6.65056 4.752 6.17856 4.912V4.928C6.77856 5.032 7.29056 5.472 7.29056 6.328C7.29056 7.424 6.53056 8 5.34656 8ZM3.67456 4.656H5.17856C5.89856 4.656 6.14656 4.36 6.14656 3.848C6.14656 3.344 5.84256 3.04 5.24256 3.04H3.67456V4.656ZM3.67456 7.24H5.28256C6.13056 7.24 6.37056 6.832 6.37056 6.296C6.37056 5.696 6.00256 5.352 5.40256 5.352H3.67456V7.24ZM12.2585 8H8.1305V2.28H12.1785V3.04H9.0105V4.664H11.7865V5.424H9.0105V7.24H12.2585V8ZM15.2701 8H14.3821V3.04H12.5341V2.28H17.1181V3.04H15.2701V8ZM17.4522 8H16.5242L18.6522 2.28H19.6042L21.7482 8H20.7882L20.3162 6.624H17.9242L17.4522 8ZM19.1162 3.096L18.1882 5.88H20.0682L19.1322 3.096H19.1162Z",
    fill: "#4B0AB0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 9,
    rx: 1.5,
    stroke: "#4B0AB0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/beta.4e8b8c5862c0fcf3904957d7c33fb222.svg";
export { ForwardRef as ReactComponent };